<template>
  <div class="container-fluid payout-page">
    <Preloader v-if="isLoading" customClasses="vh-100" />
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <FinancePayoutsForm
            disableAnimation
            v-model="editModal.show"
            mode="edit"
            :data="editModal.form"
            :title="editModal.title"
            @submit="editFinancePayouts"
            @input="onClose"
            @showDownloadModal="showDownloadPayoutModal"
            @loadingChange="handlePayoutFormLoadingChange"
            ref="financePayoutsForm"
          />

          <!-- Download Payout Modal -->
          <DownloadPayoutModal
            v-model="downloadPayoutModal.show"
            :invoice="downloadPayoutModal.payout"
            :templates="getAvailableTemplates()"
            :triggerElement="downloadPayoutModal.triggerElement"
            documentType="Payout"
            numberField="payout_number"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { permissions } from '@mocks/permissions'
import Preloader from '@components/Preloader'
import FinanceMixin from '../mixins/FinanceMixin'
import FinancePayoutsForm from '@components/modals/FinancePayoutsForm/FinancePayoutsForm.vue'
import DownloadPayoutModalMixin from '@mixins/DownloadPayoutModalMixin.js'

export default {
  components: {
    Preloader,
    FinancePayoutsForm
  },
  mixins: [FinanceMixin, DownloadPayoutModalMixin],
  data () {
    const defaultSortingField = 'payee_name'
    return {
      permissions,
      table: {
        params: {
          defaultSortingField,
          filters: null,
          sorting: '&sort[' + defaultSortingField + ']=asc',
          currentPage: 1
        }
      },
      filters: {
        'payout_number': {},
        'contractor': {},
        'partner': {},
        'payout_status': {},
        'own_bank_details': {},
        'payee_bank_details': {},
        'date_from': {},
        'date_to': {}
      },
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      getPayouts: 'finances/getPayouts',
      getAllPartners: 'partners/getAllPartners',
      getContractorBankDetails: 'finances/getContractorBankDetails',
      getPartnerBankDetails: 'finances/getPartnerBankDetails',
      getOwnBankDetails: 'finances/getOwnBankDetails',
      getPayoutsStatuses: 'finances/getPayoutsStatuses',
      getPayoutsTemplateTypes: 'finances/getPayoutsTemplateTypes'
    })
  },
  async created () {
    this.isLoading = true
    const { id } = this.$route.params

    // Load payout data and template types
    await Promise.all([
      this.fetchPayout(id),
      this.$api.finances.getPayoutsTemplateTypes()
    ])

    this.isLoading = false
  },
  methods: {
    onClose () {
      this.$router.push({ name: 'finances-payouts' })
    },
    async fetchPayout (id) {
      try {
        const resp = await this.$api.finances.getPayout(id)
        this.editModal.show = true
        this.editModal.form = resp
        this.editModal.title = `Payout ${resp.payout_number}`
      } catch (error) {
        this.errorNotifications(error)
      }
    },
    setAllOptionsFilter () {},
    async editFinancePayouts (data) {
      try {
        await this.$api.finances.updatePayouts(data)
        this.hideEditModal()
        this.onClose()
      } finally {
        // Always turn off loading state
        if (this.$refs.financePayoutsForm) {
          this.$refs.financePayoutsForm.finishLoading()
        }
      }
    },
    handlePayoutFormLoadingChange (loading) {
      // This method handles loading state changes from the payout form
      // The loading state is now managed internally by the FinancePayoutsForm component
    }
  }
}
</script>

<style lang="scss" scoped>
.payout-page {
  ::v-deep th.actions-column {
    padding-left: 24px;
  }
}

.payout-page .table__theme-default {
  table td {
    padding-top: 8px;
    padding-bottom: 3px;
  }

  .column-index {
    width: 15px;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
